import { ENUM_PropertyInvestmentType } from '@api-new/common';

export const ENUM_PropertyInvestmentTypeMap = new Map([
  [
    ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL,
    {
      text: 'Residential',
      abbreviation: 'Res.',
    },
  ],
  [
    ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_BUY_TO_LET,
    {
      text: 'Buy to let',
      abbreviation: 'BTL',
    },
  ],
]);
